<template>
  <div class="mobile-blocker gap-row-md">
      <img src="/icons/qr-grey-logo.svg" class="blocker-logo" alt="QRWaiter Logo" />
      <h4 class="qrw-heading-xs v1-grey-2-color">
          {{ $t('mobile_blocker.title') }}
      </h4>
      <p class="qrw-paragraph-md v1-grey-7-color">
        {{ $t('mobile_blocker.desc') }}
      </p>
  </div>
</template>

<script>
export default {

}
</script>

<style scope>
.mobile-blocker {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;

    background: black;

    text-align: center;

    justify-content: center;
    align-items: center;
    align-content: center;

    z-index: 10000;

    padding: 0 16px;
    box-sizing: border-box;
}

.blocker-logo {
    width: 10vh;
    margin-bottom: 2vh;
}
</style>